import { logger } from "@/utils/logger"
import { TrackPageView } from "./trackPageView.interface"

export const trackPageView: TrackPageView = (page_location, page_title): boolean => {
  if (!window?.gtag) return false
  logger.debug(`[Page:View] ${page_title} (${page_location})`)
  window.gtag("event", "page_view", { page_location, page_title })
  return true
}
